"use client";
import { useResolvedUnit } from "@/context/unit-context";
import { EfnAuth } from "@/services/auth/types";
import {
  currentPath,
  isCurrentUnit,
  isExchangeRoute,
  isFinanceRoute,
  isPlayRoute,
  isPodRoute,
  isSpecialRoute,
  isSubscriptionRoute,
} from "@/utils/url";
import classNames from "classnames";
import Link from "next/link";
import { usePathname } from "next/navigation";
import AccountButton from "./account-button";
import Logo from "./logo";
import MenuToggle from "./menu-toggle";

type HeaderProps = {
  user: EfnAuth.UserCookie | null;
  path: string | null;
};

const Header = (props: HeaderProps) => {
  const pathName = usePathname();
  const path = currentPath(props.path, pathName);
  const currentUnit = useResolvedUnit();

  return (
    <header
      className={classNames({
        "bg-static-black":
          isPlayRoute(path) || isCurrentUnit("unit-play", currentUnit),
        "!bg-red-500":
          isFinanceRoute(path) ||
          isSubscriptionRoute(path) ||
          isCurrentUnit("unit-finansmagasinet", currentUnit),
        "bg-sand-500":
          !isSpecialRoute(path) || isPodRoute(path) || isExchangeRoute(path),
      })}
    >
      <div className="container px-4 py-4 flex items-center justify-between h-[80px]">
        <a href="/" aria-label="Till startsidan">
          <Logo path={path || "/"} currentUnit={currentUnit} />
        </a>
        <div className="space-x-2 flex items-center">
          {!props.user?.products.length && !isSubscriptionRoute(path) && (
            <a href="/prenumerera" className="btn-small btn-primary">
              Prenumerera
            </a>
          )}

          {props.user?.products.includes("e-tidning") && (
            <Link
              target="_blank"
              href="/e-tidning"
              prefetch={false}
              className="font-semibold btn-small btn-comp"
            >
              E-tidning
            </Link>
          )}

          {!props.user ? (
            <MenuToggle className="btn-small btn-default" type="account">
              Logga in
            </MenuToggle>
          ) : (
            <AccountButton user={props.user} />
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;
